export const RAYK_PORTRAIT_PATH = "/rayk-portrait-cutout-v5.webp?v=20260903c";
export const RAYK_PORTRAIT_URL =
  "https://book.raykschoerling.com/rayk-portrait-cutout-v5.webp?v=20260903c";
export const RAYK_PORTRAIT_PNG_PATH = "/rayk-portrait-cutout-v5.png?v=20260903c";

export const KATRIN_PORTRAIT_PATH = "/katrin-portrait-cutout-v1.webp?v=20260920b";
export const KATRIN_PORTRAIT_PNG_PATH = "/katrin-portrait-cutout-v1.png?v=20260920b";

export const KATRIN_RAYK_PORTRAIT_PATH = "/katrin-rayk-portrait-cutout-v1.webp?v=20260921";
export const KATRIN_RAYK_PORTRAIT_PNG_PATH = "/katrin-rayk-portrait-cutout-v1.png?v=20260921";
